// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"375":"1f1b1bfa","453":"85d74713"}[chunkId] + ".chunk.js";
};